var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62124 10.0117H1.97418C0.999914 10.0117 0.209473 9.21251 0.209473 8.2275V2.28026C0.209473 1.29525 0.999914 0.496094 1.97418 0.496094H7.85653C8.8308 0.496094 9.62124 1.29525 9.62124 2.28026V10.0117ZM2.56241 7.63277H7.2683V2.87499H2.56241V7.63277ZM18.4448 10.0117H10.7977V2.28026C10.7977 1.29525 11.5881 0.496094 12.5624 0.496094H18.4448C19.419 0.496094 20.2095 1.29525 20.2095 2.28026V8.2275C20.2095 9.21251 19.419 10.0117 18.4448 10.0117ZM13.1506 7.63277H17.8565V2.87499H13.1506V7.63277ZM7.85653 20.7167H1.97418C0.999914 20.7167 0.209473 19.9175 0.209473 18.9325V12.9853C0.209473 12.0003 0.999914 11.2011 1.97418 11.2011H9.62124V18.9325C9.62124 19.9175 8.8308 20.7167 7.85653 20.7167ZM2.56241 18.3378H7.2683V13.58H2.56241V18.3378ZM10.7977 11.2011H14.3271V14.6505H16.8345V11.6174H20.2095V15.0296H17.2095V17.3045H20.2095V20.7167H16.8345V17.6836H14.5845V20.7167H11.2095V17.3045H14.2095V14.7695H10.7977V11.2011Z",
    fill: "#9F8644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeYellow);
export default __webpack_public_path__ + "static/media/code_yellow.0a7c030735003cffaa1f19e194569705.svg";
export { ForwardRef as ReactComponent };